import { render } from "./GenericDataList.vue?vue&type=template&id=32f950ee"
import script from "./GenericDataList.vue?vue&type=script&lang=js"
export * from "./GenericDataList.vue?vue&type=script&lang=js"

import "./GenericDataList.vue?vue&type=style&index=0&id=32f950ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__